import { z } from "zod";

export const ProfileImageSchema = z.string().optional();

export type ProfileImageType = z.infer<typeof ProfileImageSchema>;
